import { ComponentBase } from '@tblabs/truffle';


// REQUIRES: <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
export class Icon extends ComponentBase<HTMLBaseElement>
{
    constructor(private icon: string, color: string)
    {
        super("i");
        this.Class("material-icons")
            .Text(this.icon)
            .Color(color)
    }

    public BecomeIcon()
    {
        return this.Class("material-icons")
            .Text(this.icon).FontSize(24)
    }

    public BecomeText(text: string)
    {
        return this.RemoveClass("material-icons")
            .Text(text).FontSize(12)
    }
}
